import type { FC } from "react";
import type { PolicySummaryEntry } from "@content/policySummaries";

interface PolicySummaryProps {
  items: PolicySummaryEntry[];
}

const PolicySummary: FC<PolicySummaryProps> = ({ items }) => {
  return (
    <div className="mx-[2px] mb-16 md:-mx-1.5">
      <div className="flex flex-col gap-[10px] rounded-8 border border-[#dbdbdb] p-6">
        {items.map((entry, index) => {
          if (entry.type === "separator") {
            return (
              <div key={index} className="flex h-8 items-center">
                <div className="w-full border-t border-[#dbdbdb]" />
              </div>
            );
          }

          return (
            <div key={index} className="flex items-start gap-4">
              <div className="mt-[6px] size-4 shrink-0">{entry.icon}</div>
              <p className="font-ppMori text-base leading-[2] tracking-[-0.32px] text-black">
                {entry.content}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PolicySummary;
